export default "__VITE_ASSET__DTyCoKrz__"